import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Button } from '@monorepo/nova-ui';
import { KYC_VERIFICATION_CONSTANTS } from '../constants';
import { KycButtonContainer } from '../styled';

export const KycButton: FC = () => {
  const { t } = useTranslation('profile');

  return (
    <KycButtonContainer>
      <Link
        to={KYC_VERIFICATION_CONSTANTS.ROUTES.VERIFICATION_PATH}
        style={{
          textDecoration: 'none',
          width: '100%',
          display: 'block',
        }}
      >
        <Button
          variant="primary"
          size="sm"
          sx={{
            width: '100%',
          }}
        >
          {t(KYC_VERIFICATION_CONSTANTS.TRANSLATION_KEYS.VERIFY_BUTTON)}
        </Button>
      </Link>
    </KycButtonContainer>
  );
};
